import styles from './ProgressBar.module.css'

interface ProgressBarProps {
  /** Completed count. */
  value: number
  /** Total count. */
  max: number
  /** Accessible label, e.g. "Path progress". */
  label: string
}

/**
 * A slim, accessible completion indicator. Announces itself as a progressbar
 * with a human-readable value text; the fill has no motion beyond a short,
 * reduced-motion-aware transition.
 */
export function ProgressBar({ value, max, label }: ProgressBarProps) {
  const safeMax = Math.max(max, 1)
  const clamped = Math.min(Math.max(value, 0), safeMax)
  const percent = Math.round((clamped / safeMax) * 100)

  return (
    <div className={styles.wrap}>
      <div
        className={styles.track}
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={safeMax}
        aria-valuenow={clamped}
        aria-valuetext={`${clamped} of ${safeMax} complete`}
      >
        <div className={styles.fill} style={{ width: `${percent}%` }} />
      </div>
      <span className={styles.text}>
        {clamped} / {safeMax}
      </span>
    </div>
  )
}
